var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.available && _vm.dataList.length)?_c('Vacate',{attrs:{"data-list":_vm.dataList,"module-name":"MyVacate","type":"my"},on:{"item-click":_vm.itemClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }